import { MetricId } from '../graphql/generated/graphql-sdk';

const INTERCOM_METRIC_PREFIX = 'intercom_metric';

export const getIntercomClassNameForMetric = (metricId: MetricId) => {
  return `${INTERCOM_METRIC_PREFIX}_${metricId}`;
};
